import { Outlet } from 'react-router-dom';

function LoginLayout() {
  return (
    <>
      <div id="login-layout">
        <Outlet />
      </div>
    </>
  );
}

export default LoginLayout;